export const scaledFunctionalMapCache = new Map<string, Uint8Array>();
